import React from "react";
import { ACTIONS as T } from "@cadenza/i18n-core";
import { useLanguageContext } from "@cadenza/i18n-react";
import { ZoomControls } from "@cadenza/ui";

const ZoomControlsI18n = (props) => {
  const { STRINGS = {} } = useLanguageContext() || {};
  const messages = {
    zoomIn: STRINGS[T.ZOOM_IN] || "Zoom In",
    zoomOut: STRINGS[T.ZOOM_OUT] || "Zoom Out",
    zoomToFit: STRINGS[T.ZOOM_TO_FIT] || "Zoom to Fit",
    reset: STRINGS[T.ZOOM_RESET] || "Reset Zoom",
    min: STRINGS[T.ZOOM_MIN] || "Minimize",
    max: STRINGS[T.ZOOM_MAX] || "Maximize",
  };
  return <ZoomControls {...props} messages={messages} />;
};

export default ZoomControlsI18n;
